/*
  nl-form-errors.js (GordijnenXL)
  Vertaalt Engelse meldingen van de ITORIS Dynamic Product Options (DPO) configurator naar Nederlands.
  DPO rendert de meldingen client-side (custom template-JS en dpoValidation.rules), daarom een MutationObserver.
  Laden: <script src="{{ 'nl-form-errors.js' | asset_url }}" defer></script> vlak voor </body>.
  Werkt alleen binnen .dpo-container / #itoris_dynamicproductoptions en .validation-advice, dus goedkoop.
*/
(function () {
  'use strict';

  var EXACT = {
    'This field is required': 'Dit veld is verplicht',
    'This field is required.': 'Dit veld is verplicht.',
    'Please enter a valid number': 'Vul een geldig getal in',
    'Please enter a valid number.': 'Vul een geldig getal in.',
    'Please configure the product': 'Stel eerst het product samen',
    'Please select an option': 'Maak een keuze',
    '-- Please Select --': '-- Maak een keuze --',
    'Please Select': 'Maak een keuze',
    'out of stock': 'niet op voorraad',
    'Out of stock': 'Niet op voorraad',
    'Add to Cart': 'In winkelwagen',
    'Add to cart': 'In winkelwagen',
    'Remove': 'Verwijderen',
    'Edit': 'Bewerken',
    'Search...': 'Zoeken...',
    'Sorry, nothing found...': 'Niets gevonden...',
    'Qty': 'Aantal',
    'Loading...': 'Laden...'
  };

  var PATTERNS = [
    [/^Minimum allowed:\s*([\d.,]+)$/i, 'Minimaal $1 cm'],
    [/^Maximum allowed:\s*([\d.,]+)$/i, 'Maximaal $1 cm'],
    [/^Minimum length:\s*(\d+)$/i, 'Minimale lengte: $1 tekens'],
    [/^Maximum length:\s*(\d+)$/i, 'Maximale lengte: $1 tekens'],
    [/^Allowed file extensions:\s*(.+)$/i, 'Toegestane bestandstypen: $1'],
    [/^Maximum file size:\s*(.+)$/i, 'Maximale bestandsgrootte: $1'],
    [/^Buy (\d+) for (.+) each$/i, 'Koop $1 voor $2 per stuk'],
    [/^Stock availability:\s*(.+)$/i, 'Voorraad: $1']
  ];

  var SCOPE = '.validation-advice, .dpo-error-message, .dpo-not-allowed, .dpo-container, #itoris_dynamicproductoptions, #dpo_placeholder, .dpo_add2cart, .dpo-cart, .dpo_dd_list, .nothing-found';

  function translate(text) {
    var t = text.replace(/\s+/g, ' ').trim();
    if (!t) return null;
    if (EXACT.hasOwnProperty(t)) return EXACT[t];
    for (var i = 0; i < PATTERNS.length; i++) {
      if (PATTERNS[i][0].test(t)) return t.replace(PATTERNS[i][0], PATTERNS[i][1]);
    }
    return null;
  }

  function inScope(node) {
    var el = node.nodeType === 3 ? node.parentElement : node;
    return !!(el && el.closest && el.closest(SCOPE));
  }

  function fixTextNode(node) {
    if (!node || node.nodeType !== 3 || !inScope(node)) return;
    var parent = node.parentElement;
    if (parent && (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE')) return;
    var nl = translate(node.nodeValue);
    if (nl !== null && nl !== node.nodeValue.trim()) {
      node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), nl);
    }
  }

  function fixAttributes(el) {
    if (!el.getAttribute) return;
    ['placeholder', 'title', 'aria-label', 'value'].forEach(function (attr) {
      if (attr === 'value' && !(el.tagName === 'INPUT' && (el.type === 'submit' || el.type === 'button'))) return;
      var v = el.getAttribute(attr);
      if (!v) return;
      var nl = translate(v);
      if (nl !== null) el.setAttribute(attr, nl);
    });
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixTextNode(root); return; }
    if (root.nodeType !== 1) return;
    if (!inScope(root) && !(root.querySelector && root.querySelector(SCOPE))) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null);
    var n = root;
    do {
      if (n.nodeType === 3) fixTextNode(n); else fixAttributes(n);
    } while ((n = walker.nextNode()));
  }

  var scheduled = false;
  var pending = [];
  function flush() {
    scheduled = false;
    var items = pending; pending = [];
    for (var i = 0; i < items.length; i++) walk(items[i]);
  }
  function queue(node) {
    pending.push(node);
    if (!scheduled) { scheduled = true; (window.requestAnimationFrame || setTimeout)(flush, 0); }
  }

  function start() {
    if (!document.body || window.__gxlNlFormErrors) return;
    window.__gxlNlFormErrors = true;
    walk(document.body);
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') { queue(r.target); continue; }
        if (r.type === 'attributes') { queue(r.target); continue; }
        for (var j = 0; j < r.addedNodes.length; j++) queue(r.addedNodes[j]);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder', 'title', 'aria-label', 'value'] });
    if (window.jQuery) {
      window.jQuery(window).on('dpo_initialized dpoPriceUpdate', function () { queue(document.body); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
})();

/*
  gxl-dpo-optional (GordijnenXL): DPO-override, alleen actief op pagina's met #itoris_dynamicproductoptions.
  1. Vrije tekstvelden met label "Referentie" of "Naam Kamer" zijn niet meer verplicht: de klasse 'required' op het label,
     het attribuut validation='{"required":true}' en de config-vlag (is_require) worden client-side weggehaald, en
     dpoValidation.rules.required wordt omwikkeld zodat die velden altijd geldig zijn.
  2. window.dpoObserver.extraATCDelay (custom JS van de bouwer zet 5000 ms) wordt vlak voor de DPO-submit op ATC_DELAY_MS gezet.
     LET OP: 0 valt in DPO terug op 5000 (`extraATCDelay ? extraATCDelay : 5000`), daarom 0.1. De vertraging bestaat omdat
     ITORIS vlak daarvoor server-side een verborgen variant aanmaakt; faalt /cart/add in de browsertest (404/422), zet dan 1500.
*/
(function () {
  'use strict';
  var OPTIONAL_LABEL = /^(referentie|naam kamer)\b/i;
  var ATC_DELAY_MS = 0.1;

  function root() { return document.getElementById('itoris_dynamicproductoptions'); }

  function isOptionalField(el) {
    if (!el) return false;
    var field = el.closest ? el.closest('.field') : null;
    var label = field && field.querySelector('label');
    return !!(label && OPTIONAL_LABEL.test(label.textContent.trim()));
  }

  function relaxOptional() {
    var r = root();
    if (!r) return;
    var fields = r.querySelectorAll('.field');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var label = field.querySelector('label');
      if (!label || !OPTIONAL_LABEL.test(label.textContent.trim())) continue;
      label.classList.remove('required');
      var inputs = field.querySelectorAll('input[type="text"], textarea');
      for (var j = 0; j < inputs.length; j++) {
        var inp = inputs[j];
        inp.classList.remove('required-entry');
        inp.removeAttribute('required');
        inp.removeAttribute('aria-required');
        var v = inp.getAttribute('validation');
        if (v && v.indexOf('required') !== -1) {
          try { var o = JSON.parse(v); delete o.required; inp.setAttribute('validation', JSON.stringify(o)); } catch (e) { inp.removeAttribute('validation'); }
        }
        if (inp.config) { inp.config.is_require = '0'; inp.config.required = false; }
        var adv = field.querySelector('.validation-advice');
        if (adv && !inp.value) adv.remove();
      }
    }
    var opts = window.dpoOptions && window.dpoOptions.options;
    if (opts && opts.length) {
      for (var k = 0; k < opts.length; k++) {
        var o2 = opts[k];
        if (o2 && o2.title && OPTIONAL_LABEL.test(String(o2.title).trim()) && (o2.type === 'field' || o2.type === 'area')) {
          o2.is_require = '0'; o2.required = false;
        }
      }
    }
  }

  function wrapRule() {
    var rules = window.dpoValidation && window.dpoValidation.rules;
    if (!rules || typeof rules.required !== 'function' || rules.required.__gxlWrapped) return;
    var orig = rules.required;
    var wrapped = function (field) {
      var el = field && field[0] ? field[0] : field;
      if (isOptionalField(el)) return false;
      return orig.apply(this, arguments);
    };
    wrapped.__gxlWrapped = true;
    rules.required = wrapped;
  }

  function setAtcDelay() {
    if (window.dpoObserver && 'extraATCDelay' in window.dpoObserver) window.dpoObserver.extraATCDelay = ATC_DELAY_MS;
    if ('extraATCDelay' in window) window.extraATCDelay = ATC_DELAY_MS;
  }

  function apply() { relaxOptional(); wrapRule(); setAtcDelay(); }

  function init() {
    if (window.__gxlDpoOptional) return;
    window.__gxlDpoOptional = true;
    apply();
    if (window.jQuery) {
      window.jQuery(window).on('dpo_initialized dpoPriceUpdate dpo_cart_initialized', apply);
    }
    // capture-fase: loopt vóór de jQuery-handlers van DPO op de knop
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('form[action*="cart/add"] [type="submit"], #itoris_dynamicoptions_add_to_cart, [dpo_add2cart], .dpo_add2cart') : null;
      if (t) apply();
    }, true);
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled || !root()) return;
      scheduled = true;
      (window.requestAnimationFrame || setTimeout)(function () { scheduled = false; apply(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
